export default __webpack_public_path__ + "static/media/char_head_prem_003.a0c2147f.png";